import React, { useState } from "react";
import { Hero } from "./components/Hero";
import { Testimonials } from "./components/Testimonials";
import { PainPoints } from "./components/PainPoints";
import { Audience } from "./components/Audience";
import { Overview } from "./components/Overview";
import { Volumes } from "./components/Volumes";
import { Bonuses } from "./components/Bonuses";
import { Comparison } from "./components/Comparison";
import { Offer } from "./components/Offer";
import { PremiumUpsell } from "./components/PremiumUpsell";
import { Guarantee } from "./components/Guarantee";
import { FAQ } from "./components/FAQ";
import { FinalOffer } from "./components/FinalOffer";
import { Footer } from "./components/Footer";
import { StickyCTA } from "./components/StickyCTA";
import { useCountdown } from "./hooks/useCountdown";
import { useMetaPixel } from "./hooks/useMetaPixel";
import type { PlanId } from "./types/pricing";
const START_SECONDS = 23 * 3600 + 49 * 60 + 1;
export function App() {
  useMetaPixel();
  const time = useCountdown(START_SECONDS);
  const [plan, setPlan] = useState<PlanId>("premium");
  return <div className="min-h-screen w-full bg-paper" data-id="element-0" data-mp="3mkhofzsx1e8o">
      <Hero data-id="element-1" data-mp="3rc9du70c5dx8" />
      <main data-id="element-2" data-mp="3rcj846sey78q">
        <Testimonials data-id="element-3" data-mp="3rbzmaezn6ypf" />
        <PainPoints data-id="element-4" data-mp="3rdkgu4lyihna" />
        <Audience data-id="element-5" data-mp="3recerm310rgq" />
        <Overview data-id="element-6" data-mp="5yjsutqtdfe" />
        <Volumes data-id="element-7" data-mp="6hrlipoilfp" />
        <Bonuses data-id="element-8" data-mp="4wv3njt0sf7" />
        <Comparison data-id="element-9" data-mp="5gfrc0u9uwx" />
        <Offer time={time} plan={plan} onPlanChange={setPlan} data-id="element-10" data-mp="82jt1oitsae" />
        <PremiumUpsell data-id="element-11" data-mp="2zmepodo7rua5" />
        <Guarantee data-id="element-12" data-mp="2zmwhmy3ufmc9" />
        <FAQ data-id="element-13" data-mp="2znfyebhrc4op" />
        <FinalOffer time={time} plan={plan} onPlanChange={setPlan} data-id="element-14" data-mp="33mf1dqjxhrdi" />
      </main>
      <Footer data-id="element-15" data-mp="33oi0r16z0wuw" />
      <StickyCTA time={time} data-id="element-16" data-mp="38m1gk5jbhhoy" />
    </div>;
}